// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var StateMachine$SmartcutsMacros = require("./StateMachine.bs.js");
var ExtensionMessagingBuilders$SmartcutsMacros = require("./ExtensionMessagingBuilders.bs.js");
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = require("./InterfaceBtwnContentScriptAndBg.bs.js");

function message_encode(encoder_message, v) {
  return [
          "Message_FromTabWithStateMachineDeps",
          Curry._1(encoder_message, v._0)
        ];
}

function message_decode(decoder_message, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Message_FromTabWithStateMachineDeps") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(decoder_message, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* Message_FromTabWithStateMachineDeps */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode(encoder_response, v) {
  return [
          "Response_FromTabWithStateMachineDeps",
          Curry._1(encoder_response, v._0)
        ];
}

function response_decode(decoder_response, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Response_FromTabWithStateMachineDeps") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(decoder_response, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* Response_FromTabWithStateMachineDeps */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function result_encode(encoder_response, v) {
  return Decco.resultToJson((function (param) {
                return response_encode(encoder_response, param);
              }), Decco.stringToJson, v);
}

function result_decode(decoder_response, v) {
  return Decco.resultFromJson((function (param) {
                return response_decode(decoder_response, param);
              }), Decco.stringFromJson, v);
}

function wrapMessage(message) {
  return /* Message_FromTabWithStateMachineDeps */{
          _0: message
        };
}

function wrapResponse(response) {
  return /* Response_FromTabWithStateMachineDeps */{
          _0: response
        };
}

function unwrapMessage(message) {
  return message._0;
}

function unwrapResponse(response) {
  return response._0;
}

var AllWrapper = {
  message_encode: message_encode,
  message_decode: message_decode,
  response_encode: response_encode,
  response_decode: response_decode,
  result_encode: result_encode,
  result_decode: result_decode,
  wrapMessage: wrapMessage,
  wrapResponse: wrapResponse,
  unwrapMessage: unwrapMessage,
  unwrapResponse: unwrapResponse
};

function Make(ContentScriptStateMachine) {
  var message_encode = function (v) {
    return [
            "NotifyBgOfContentScriptFailure",
            Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, ContentScriptStateMachine.otherFailureReason_encode, v._0),
            Curry._1(ContentScriptStateMachine.errorContext_encode, v._1),
            StateMachine$SmartcutsMacros.$$History.t_encode(ContentScriptStateMachine.state_encode, ContentScriptStateMachine.event_encode, ContentScriptStateMachine.listener_encode, ContentScriptStateMachine.sideEffect_encode, v._2)
          ];
  };
  var message_decode = function (v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
      return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */3) {
      return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
      return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "NotifyBgOfContentScriptFailure") {
      if (tagged.length !== 4) {
        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
      }
      var match$1 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, ContentScriptStateMachine.otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 1));
      var match$2 = Curry._1(ContentScriptStateMachine.errorContext_decode, Belt_Array.getExn(jsonArr$1, 2));
      var match$3 = StateMachine$SmartcutsMacros.$$History.t_decode(ContentScriptStateMachine.state_decode, ContentScriptStateMachine.event_decode, ContentScriptStateMachine.listener_decode, ContentScriptStateMachine.sideEffect_decode, Belt_Array.getExn(jsonArr$1, 3));
      if (match$1.TAG === /* Ok */0) {
        if (match$2.TAG === /* Ok */0) {
          if (match$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotifyBgOfContentScriptFailure */{
                      _0: match$1._0,
                      _1: match$2._0,
                      _2: match$3._0
                    }
                  };
          }
          var e = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[2]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = match$2._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: "[1]" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = match$1._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[0]" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
  };
  var response_encode = function (v) {
    return ["BgDidAckTabError"];
  };
  var response_decode = function (v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
      return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */3) {
      return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
      return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "BgDidAckTabError") {
      if (tagged.length !== 1) {
        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
      } else {
        return {
                TAG: /* Ok */0,
                _0: /* BgDidAckTabError */0
              };
      }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
  };
  var MR_NotifyBgOfContentScriptFailure = {
    message_encode: message_encode,
    message_decode: message_decode,
    response_encode: response_encode,
    response_decode: response_decode
  };
  var message_encode$1 = function (v) {
    return [
            "NotifyBgOfContentScriptResponseFailure",
            InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v._0),
            Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, ContentScriptStateMachine.otherFailureReason_encode, v._1),
            Curry._1(ContentScriptStateMachine.errorContext_encode, v._2),
            StateMachine$SmartcutsMacros.$$History.t_encode(ContentScriptStateMachine.state_encode, ContentScriptStateMachine.event_encode, ContentScriptStateMachine.listener_encode, ContentScriptStateMachine.sideEffect_encode, v._3)
          ];
  };
  var message_decode$1 = function (v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
      return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */3) {
      return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
      return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "NotifyBgOfContentScriptResponseFailure") {
      if (tagged.length !== 5) {
        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
      }
      var match$1 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Array.getExn(jsonArr$1, 1));
      var match$2 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, ContentScriptStateMachine.otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
      var match$3 = Curry._1(ContentScriptStateMachine.errorContext_decode, Belt_Array.getExn(jsonArr$1, 3));
      var match$4 = StateMachine$SmartcutsMacros.$$History.t_decode(ContentScriptStateMachine.state_decode, ContentScriptStateMachine.event_decode, ContentScriptStateMachine.listener_decode, ContentScriptStateMachine.sideEffect_decode, Belt_Array.getExn(jsonArr$1, 4));
      if (match$1.TAG === /* Ok */0) {
        if (match$2.TAG === /* Ok */0) {
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: /* NotifyBgOfContentScriptResponseFailure */{
                        _0: match$1._0,
                        _1: match$2._0,
                        _2: match$3._0,
                        _3: match$4._0
                      }
                    };
            }
            var e = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[3]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[2]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = match$2._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: "[1]" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = match$1._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[0]" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
  };
  var response_encode$1 = function (v) {
    return ["BgDidAckNotifyBgOfContentScriptResponseFailure"];
  };
  var response_decode$1 = function (v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
      return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */3) {
      return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
      return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "BgDidAckNotifyBgOfContentScriptResponseFailure") {
      if (tagged.length !== 1) {
        return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
      } else {
        return {
                TAG: /* Ok */0,
                _0: /* BgDidAckNotifyBgOfContentScriptResponseFailure */0
              };
      }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
  };
  var MR_NotifyBgOfContentScriptResponseFailure = {
    message_encode: message_encode$1,
    message_decode: message_decode$1,
    response_encode: response_encode$1,
    response_decode: response_decode$1
  };
  var message_encode$2 = function (v) {
    if (v.TAG === /* Message_NotifyBgOfContentScriptFailure */0) {
      return [
              "Message_NotifyBgOfContentScriptFailure",
              message_encode(v._0)
            ];
    } else {
      return [
              "Message_NotifyBgOfContentScriptResponseFailure",
              message_encode$1(v._0)
            ];
    }
  };
  var message_decode$2 = function (v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
      return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */3) {
      return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
      return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */0) {
      switch (match._0) {
        case "Message_NotifyBgOfContentScriptFailure" :
            if (tagged.length !== 2) {
              return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var v0 = message_decode(Belt_Array.getExn(jsonArr$1, 1));
            if (v0.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Message_NotifyBgOfContentScriptFailure */0,
                        _0: v0._0
                      }
                    };
            }
            var e = v0._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[0]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
        case "Message_NotifyBgOfContentScriptResponseFailure" :
            if (tagged.length !== 2) {
              return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var v0$1 = message_decode$1(Belt_Array.getExn(jsonArr$1, 1));
            if (v0$1.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Message_NotifyBgOfContentScriptResponseFailure */1,
                        _0: v0$1._0
                      }
                    };
            }
            var e$1 = v0$1._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[0]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
        default:
          
      }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
  };
  var response_encode$2 = function (v) {
    if (v.TAG === /* Response_NotifyBgOfContentScriptFailure */0) {
      return [
              "Response_NotifyBgOfContentScriptFailure",
              ["BgDidAckTabError"]
            ];
    } else {
      return [
              "Response_NotifyBgOfContentScriptResponseFailure",
              ["BgDidAckNotifyBgOfContentScriptResponseFailure"]
            ];
    }
  };
  var response_decode$2 = function (v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
      return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */3) {
      return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
      return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */0) {
      switch (match._0) {
        case "Response_NotifyBgOfContentScriptFailure" :
            if (tagged.length !== 2) {
              return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var v0 = response_decode(Belt_Array.getExn(jsonArr$1, 1));
            if (v0.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Response_NotifyBgOfContentScriptFailure */0,
                        _0: v0._0
                      }
                    };
            }
            var e = v0._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[0]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
        case "Response_NotifyBgOfContentScriptResponseFailure" :
            if (tagged.length !== 2) {
              return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
            }
            var v0$1 = response_decode$1(Belt_Array.getExn(jsonArr$1, 1));
            if (v0$1.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Response_NotifyBgOfContentScriptResponseFailure */1,
                        _0: v0$1._0
                      }
                    };
            }
            var e$1 = v0$1._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[0]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
        default:
          
      }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
  };
  var MR_All = {
    message_encode: message_encode$2,
    message_decode: message_decode$2,
    response_encode: response_encode$2,
    response_decode: response_decode$2
  };
  var message_encode$3 = message_encode;
  var message_decode$3 = message_decode;
  var response_encode$3 = function (v) {
    return ["BgDidAckTabError"];
  };
  var response_decode$3 = response_decode;
  var allMessage_encode = message_encode$2;
  var allMessage_decode = message_decode$2;
  var allResponse_encode = response_encode$2;
  var allResponse_decode = response_decode$2;
  var responseError_encode = Decco.stringToJson;
  var responseError_decode = Decco.stringFromJson;
  var wrapMessageAsAllMessage = function (message) {
    return {
            TAG: /* Message_NotifyBgOfContentScriptFailure */0,
            _0: message
          };
  };
  var unwrapAllResponseAsResponse = function (allResponse) {
    if (allResponse.TAG === /* Response_NotifyBgOfContentScriptFailure */0) {
      return allResponse._0;
    } else {
      return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    }
  };
  var wrapResponseAsAllResponse = function (response) {
    return {
            TAG: /* Response_NotifyBgOfContentScriptFailure */0,
            _0: response
          };
  };
  var MRTransform_NotifyBgOfContentScriptFailure = {
    message_encode: message_encode$3,
    message_decode: message_decode$3,
    response_encode: response_encode$3,
    response_decode: response_decode$3,
    allMessage_encode: allMessage_encode,
    allMessage_decode: allMessage_decode,
    allResponse_encode: allResponse_encode,
    allResponse_decode: allResponse_decode,
    responseError_encode: responseError_encode,
    responseError_decode: responseError_decode,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse
  };
  var partial_arg = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;
  var NotifyBgOfContentScriptFailure = partial_arg(MRTransform_NotifyBgOfContentScriptFailure, AllWrapper);
  var message_encode$4 = message_encode$1;
  var message_decode$4 = message_decode$1;
  var response_encode$4 = function (v) {
    return ["BgDidAckNotifyBgOfContentScriptResponseFailure"];
  };
  var response_decode$4 = response_decode$1;
  var allMessage_encode$1 = message_encode$2;
  var allMessage_decode$1 = message_decode$2;
  var allResponse_encode$1 = response_encode$2;
  var allResponse_decode$1 = response_decode$2;
  var responseError_encode$1 = Decco.stringToJson;
  var responseError_decode$1 = Decco.stringFromJson;
  var wrapMessageAsAllMessage$1 = function (message) {
    return {
            TAG: /* Message_NotifyBgOfContentScriptResponseFailure */1,
            _0: message
          };
  };
  var unwrapAllResponseAsResponse$1 = function (allResponse) {
    if (allResponse.TAG === /* Response_NotifyBgOfContentScriptFailure */0) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
    } else {
      return allResponse._0;
    }
  };
  var wrapResponseAsAllResponse$1 = function (response) {
    return {
            TAG: /* Response_NotifyBgOfContentScriptResponseFailure */1,
            _0: response
          };
  };
  var MRTransform_NotifyBgOfContentScriptResponseFailure = {
    message_encode: message_encode$4,
    message_decode: message_decode$4,
    response_encode: response_encode$4,
    response_decode: response_decode$4,
    allMessage_encode: allMessage_encode$1,
    allMessage_decode: allMessage_decode$1,
    allResponse_encode: allResponse_encode$1,
    allResponse_decode: allResponse_decode$1,
    responseError_encode: responseError_encode$1,
    responseError_decode: responseError_decode$1,
    wrapMessageAsAllMessage: wrapMessageAsAllMessage$1,
    unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$1,
    wrapResponseAsAllResponse: wrapResponseAsAllResponse$1
  };
  var partial_arg$1 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;
  var NotifyBgOfContentScriptResponseFailure = partial_arg$1(MRTransform_NotifyBgOfContentScriptResponseFailure, AllWrapper);
  var message_encode$5 = message_encode$2;
  var message_decode$5 = message_decode$2;
  var response_encode$5 = response_encode$2;
  var response_decode$5 = response_decode$2;
  var All = {
    message_encode: message_encode$5,
    message_decode: message_decode$5,
    response_encode: response_encode$5,
    response_decode: response_decode$5
  };
  return {
          MR_NotifyBgOfContentScriptFailure: MR_NotifyBgOfContentScriptFailure,
          MR_NotifyBgOfContentScriptResponseFailure: MR_NotifyBgOfContentScriptResponseFailure,
          MR_All: MR_All,
          MRTransform_NotifyBgOfContentScriptFailure: MRTransform_NotifyBgOfContentScriptFailure,
          NotifyBgOfContentScriptFailure: NotifyBgOfContentScriptFailure,
          MRTransform_NotifyBgOfContentScriptResponseFailure: MRTransform_NotifyBgOfContentScriptResponseFailure,
          NotifyBgOfContentScriptResponseFailure: NotifyBgOfContentScriptResponseFailure,
          All: All
        };
}

exports.AllWrapper = AllWrapper;
exports.Make = Make;
/* Util-SmartcutsMacros Not a pure module */
